import React from "react";

import { SquareButton } from "@themuse/design-system";

import { appCastJobApply } from "../utils/appcast";
import { getApplyRedirectUrl, IMetadataObj } from "../utils/strings";
import { museTrack } from "../utils/tracking";
import { externalJobApply } from "../utils/externalJobApply";

interface JobApplyButtonProps {
    jobId: number;
    setIsOpen?: (x: boolean) => void;
    className?: string;
    trackingProps?: IMetadataObj;
    isDirectApply: boolean;
    vendor?: string
    directApplyVendor: string;
}

export const JobApplyButton = (props: JobApplyButtonProps) => {
    const {
        className,
        jobId,
        trackingProps,
        setIsOpen,
        isDirectApply,
        directApplyVendor
    } = props;

    const [redirectUrl, setRedirectUrl] = React.useState(getApplyRedirectUrl(jobId));
    const buttonText = isDirectApply ? "Quick Apply" : "Apply on company site";
    const targetPageSection = isDirectApply ? "direct_apply_form" : "off_site";
    const trackingClass = "track-job-apply-button";
    const vendorTag = directApplyVendor
        ? { type: "direct_apply_vendor", value: directApplyVendor }
        : null;
    const snowplowTrackingProps = {
        sp_click_button_text: buttonText,
        sp_click_button_type: "apply",
        sp_click_component: "button",
        sp_click_position: trackingProps?.placement_position === "right_rail" ? "right_rail" : "bottom",
        sp_click_target_page_section: targetPageSection,
        sp_tags: [vendorTag].filter(Boolean)
    };

    const linkHandler = () => {
        externalJobApply(trackingProps.company_id, jobId);
        museTrack("Job Apply Clicked", trackingProps);
        appCastJobApply();
    };

    const modalHandler = () => {
        setIsOpen?.(true);
        linkHandler();
    };

    const btnProps = {
        className: `${className} ${trackingClass}`,
        href: isDirectApply ? null : redirectUrl,
        target: isDirectApply ? null : "_blank",
        onClick: isDirectApply ? modalHandler : linkHandler,
        color: "secondary-100",
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify(snowplowTrackingProps)
    };

    const cleanProps = Object.keys(btnProps)
        .filter((k) => !!btnProps[k])
        .reduce((a, k) => ({ ...a, [k]: btnProps[k] }), {});

    React.useEffect(() => {
        setRedirectUrl(`${redirectUrl}${window.location.search}`);
    }, []);

    return (
        <SquareButton {...cleanProps}>
            {buttonText}
        </SquareButton>
    );
};
